<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="''"></navBox>
			<!--导航-->
			<!--协议内容-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="content_box"
			>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;text-align: center">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 27px">
							Privacy Policy
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						This Privacy Policy describes how UC reagent
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						(&quot;UC reagent&quot;,
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						 &quot;we&quot;, &quot;our&quot; or &quot;us&quot;) handles the collection,
						storage, sharing, and protection of the personal information of visitors,
						users, and others who access our
					</span>
					<a href="https://ucreagent.com/">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(5, 99, 193)">
								www.ucreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						website (the &quot;Website&quot;).
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We value individuals&#39; privacy concerns, so this Privacy Policy outlines
						what data we collect, how it is used, with whom it is shared, the choices
						available to individuals, and other details regarding privacy practices.
						By accessing any part of the website, users agree that their personal information
						may be collected, stored, used, transferred, and disclosed by UC reagent as
						described here.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Kindly read the following terms to learn more about your privacy, as this
						Privacy Policy (&quot;Policy&quot;) will help you understand how we collect
						and use personal information from those who access and use our website.
						It also helps you understand the rights and choices that you have with
						respect to your personal information.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						By accessing or using the website in any manner, you acknowledge that
						you accept the practices and policies outlined in this Privacy Policy,
						and you hereby consent that we will collect, use, and share your information
						in the following ways.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							1. Changes to this Privacy Policy
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We reserve the right to make changes to this policy at any given time.
						If you want to make sure that you are up to date with the latest changes,
						we advise you to visit this page frequently.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							2. What does this privacy policy cover?
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						This policy applies to our website, and it governs any and all data collection
						and usage by us in compliance with applicable regulations. By using our
						website, you consent to the data collection procedures expressed in this
						policy.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We gather various types of information from our users, as explained in
						more detail below, and we use this information internally in connection
						with our website, including to personalize, provide, and improve our website,
						to allow you to learn more about us, to communicate with you, and to analyze
						how you use the website. In certain cases, we may also share some information
						with third parties, but only as described below.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Please note that this policy does not govern the collection and use of
						information by parties that we do not control nor by individuals not employed
						or managed by us. If you visit a Website made available via our website
						or link, review its privacy policy before providing the website with information.
						It is highly recommended that you review the privacy policies and statements
						of any website you choose to use or frequent to better understand how such
						websites garner, use, and share the information collected.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							3. Information we collect
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						When you make use of our website, we may collect and process certain personal
						information about you, which may include the following as described below:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 64px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							A.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Information you provide:
						</span>
					</strong>
					<strong>
						<span style="font-family: Helvetica;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							<br/></span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&quot;Personal Information&quot;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						means any information which, either alone or in combination with other
						information we hold about you, identifies you as an individual, including,
						for example, your contact information such as your name, email address,
						telephone, location information, demographic information as well as any
						other non-public information about you that is associated with or linked
						to any of the foregoing data which you may be required to provide when
						using the Website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 64px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&quot;Anonymous/Aggregated Data&quot;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						means data that is not associated with or linked to your Personal Information;
						Anonymous Data does not, by itself, permit the identification of individual
						persons. We collect, use, and share Anonymous Data, such as statistical
						or demographic data, for any purpose. Anonymous Data may be derived from
						your personal information but is not considered personal information in
						law as such data does not directly or indirectly reveal your identity.
						For instance, we may aggregate or anonymize your usage data to calculate
						the percentage of users accessing a specific Service feature. However,
						suppose we combine or connect Aggregated Data with your personal information
						so that it can directly or indirectly identify you; we will treat the combined
						data as personal information, which will be used in accordance with this
						privacy notice.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 64px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Please note that you can choose not to provide us with certain information,
						but this may limit the features of the website you can use.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 56px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							B.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Automated information collection
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 56px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may collect certain information (which does not identify you as an
						individual) about your use of the website through the use of tracking technologies
						or by other passive means and other relevant statistics, including the
						following:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						i.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Device and location information:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Through third-party partners, we may also collect information about your
						mobile, computer device, and internet connection, such as your operating
						system, IP address, or browser type. For example, we make use of Google
						Analytics to track and collect these kinds of information. We may also
						collect location information through the use of geolocation technology.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						ii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Cookies:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						When you access and/or make use of our website, through third-party partners
						like Google Analytics, we may send one or more cookies (small text files
						containing a string of characters) to your device that uniquely identifies
						your browser. We use cookies to improve the quality of the software and
						service by storing user preferences and tracking user trends. A pop-up
						requesting your consent may be displayed to you before Cookies are placed
						on your browser or device. By consenting to the placement of Cookies on
						your device, you enable us to offer you the best possible experience when
						you make use of our website. You may refuse permission to the placement
						of Cookies if you so desire; however, certain aspects of Our website may
						not work properly or as intended.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You can also adjust cookie settings in your browser, including blocking
						or deleting cookies. Settings vary by browser, so check your browser&#39;s
						help function to learn more. The type of cookies we use can generally be
						categorized under one of the four categories below. These are cookies required
						for our website&#39;s operation and to provide you with the best browsing
						experience, and they fall into the following categories:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 160px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							·
						</span>
					</span>
					<span style="font-family: Symbol;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Operational cookies (Also known as Necessary Cookies): These cookies are
						essential, as they enable you to move around the website and use its features,
						such as keeping you locked in during your visit to the website and accessing
						certain areas of the website and the services that we make available to
						you. You can decline these cookies by changing your browser settings, but
						because they are strictly necessary for the operation of the website, we
						cannot provide you with the website services without them.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 160px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							·
						</span>
					</span>
					<span style="font-family: Symbol;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Performance cookies: We use performance cookies to assess how visitors
						interact with our website, including page response times, download errors,
						length of visits, page interaction data, etc. This cookie helps us to improve
						the way our website works, for example, by ensuring that users can find
						what they are looking for easily. The information we collect using these
						cookies does not gather information about your identity. All information
						collected using these cookies are anonymous and is only used to improve
						how the website works.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 160px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							·
						</span>
					</span>
					<span style="font-family: Symbol;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Functional cookies: We use functional cookies to remember your preferences,
						such as language selection, so we can enhance and customize your experience.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 160px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							·
						</span>
					</span>
					<span style="font-family: Symbol;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Advertising cookies: We use advertising cookies to deliver relevant ads
						to you more effectively, improve campaign performance reports, and avoid
						showing ads you have already seen.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 160px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							·
						</span>
					</span>
					<span style="font-family: Symbol;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Social media cookies: We use social media cookies to allow you to share
						or like content relevant to our website directly on social media platforms.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 160px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							·
						</span>
					</span>
					<span style="font-family: Symbol;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Third-party cookies: We partner with third parties who also set cookies
						when you visit our website to allow them to deliver the services they are
						providing. For example, third-party analytics services that help us understand
						the use of our website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iv.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Links:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The contents on the Website may include links in a format that enables
						us to keep track of whether IP addresses have followed these links. We
						use this information to improve the quality of our products and design.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						v.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Beacons:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Beacons (also known as &quot;pixel tags&quot; or &quot;clear GIFs&quot;)
						are 1
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Times Roman">
							×
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						1 single-pixel graphics that allow us to count the number of users who
						have accessed the Website and to recognize users by accessing our cookies.
						We may employ beacons to facilitate website administration and navigation,
						track the actions of website users, compile aggregated statistics about
						website usage and response rates, and provide an enhanced online experience
						for visitors to the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						vi.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Analytics services:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may use third-party analytics services (&quot;Analytics Services&quot;),
						such as Google Analytics, Facebook Pixel, and other third-party analytics
						services, to help monitor, visualize, integrate, and analyze how users
						make use of our Website. The information generated by the cookies or other
						technologies about your use of our Website (the &quot;Analytics Information&quot;)
						may be transmitted to the third-party Analytics Services. The Analytics
						Services providers use such Analytics Information to compile reports on
						user activity. The Analytics Services providers may also transfer the Analytics
						Information to third parties where required to do so by law, or where such
						third parties process Analytics Information on their behalf. Each Analytics
						Service provider&#39;s ability to use and share Analytics Information is
						restricted by such Analytics Service provider&#39;s terms of use and privacy
						policy.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 64px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							C.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Information automatically collected by third parties about you
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 32px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Some embedded content on the website may be served by third-party service
						providers. Please note that these companies may also use cookies or similar
						technologies to collect data about you on the Website and the Internet.
						Data collection and use by those third parties is subject to their privacy
						policies.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 32px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Please rest assured that this Website will only collect personal information
						that you knowingly and willingly provide us through surveys, completed
						forms, and emails. We intend to use personal information only for the purpose
						for which it was requested and for any additional uses specifically provided
						for in this Policy.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							4. What do we use your personal information for?
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We use the information collected from you to provide, improve, and develop
						the services we provide to you, communicate with you, offer you a better
						service, and protect us and our users. When you interact with or use our
						Website, we use various technologies to collect information about you for
						various reasons.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						i.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Provision of the UC reagent services to you.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							ii.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							For communication purposes:
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may send emails, newsletters, updates, and related emails to the email
						address you provide to us and for informational and operational purposes,
						such as customer service, and other service-related purposes. We use personal
						information that we gather from you to communicate with you in relation
						to your use of our website and services.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							iii.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Fraud detection and prevention:
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Increase and maintain the safety and security of our website and services
						and prevent misuse. We use personal information to detect and prevent fraud
						and abuse to protect the security and ensure the safety of our users, UC reagent,
						and others.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We also use collected information to protect against, identify, and prevent
						fraud and other criminal activity, claims, and other liabilities.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							iv.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Provide, troubleshoot, and improve our Website and Services:
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We use your personal information to understand, diagnose, troubleshoot,
						and fix issues with our website. We also use such information to operate,
						evaluate, develop, manage, and improve our website (including operating,
						administering, analyzing, and improving our products and services; developing
						new offerings and services; managing and evaluating the effectiveness of
						our communications; performing accounting, auditing, billing reconciliation
						and collection activities and other internal functions;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						v.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						To evaluate and develop new features, technologies, and improvements to
						our website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 128px;">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							vi.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Comply with and enforce applicable legal requirements:
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						In certain cases, we collect your personal information to stay in compliance
						with laws and relevant industry standards and policies, including this
						Privacy Notice and our Terms and Conditions.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							5. Personal Information that we share
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Except as described below, we do not sell, rent, trade, or otherwise share
						personal information collected through the Website:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						i.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Service providers:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We work with third-party service providers to make certain services available
						to you for use on or through our website or employ other companies and
						individuals to perform certain functions on our behalf. Such services may
						include new feature development and enhancement, customer service, marketing,
						and website usage analytics. We may share personal information or any information
						collected through the website with these third parties for the purpose
						of enabling them to provide these services.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						ii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Subsidiaries and affiliates:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may share personal information or any information collected through
						your use of the website with our subsidiaries and affiliates for the purposes
						for which you provided the information or as reasonably necessary for our
						internal administrative and business purposes.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Analytics Partners:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						When you provide your personal information to us, we may make certain
						personal information available to certain third parties for analytics purposes,
						including but not limited to leveraging third-party tools and services
						to host, track, integrate, manage user&#39;s interests, usage pattern,
						and/or functionality available through our website. We will only share
						your personal information with analytics partners to improve our service
						and/or to deliver the UC reagent services to you. We do not in any way sell
						your personal information to advertisers.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iv.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Merger and acquisition:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may disclose or transfer personal information or any information collected
						through your usage of our website to third parties who acquire all or a
						portion of our business, whether such acquisition is by way of merger,
						consolidation, or purchase of all or a portion of our assets, or in connection
						with any bankruptcy or reorganization proceeding brought by or against
						us.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						v.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Compliance with laws:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may disclose personal information or any information collected through
						your usage of our website if we are required to do so by law or pursuant
						to legal process, in response to a request from government officials, law
						enforcement authorities, or a valid subpoena, or as necessary or appropriate
						in connection with an investigation of illegal activity, including without
						limitation to prevent, investigate, detect or prosecute any criminal offense
						or attack.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						vi.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Consent:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may share personal information in accordance with any consent you provide.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 21px 64px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						vii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Aggregate Information:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We share aggregate statistical data for the improvement of our website.
						We may also share aggregated or de-identified information with third parties
						at our discretion.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							6. Data retention and deletion
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We keep your personal information only as long as necessary to provide
						you with our website and for legitimate and essential business purposes,
						such as maintaining the performance of our website, making data-driven
						business decisions about new features and offerings, complying with our
						legal obligations, and resolving disputes. We keep some of your personal
						information for as long as you are a user of our website.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						If you request, we will delete or anonymize your personal information
						so that it no longer identifies you, unless we are legally allowed or required
						to maintain certain personal information, including situations such as
						the following:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 100px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						i.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						If there is an unresolved issue relating to your use of the service, such
						as an unresolved claim or dispute, we will retain the necessary personal
						information until the issue is resolved;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 100px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						ii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Where we need to retain the personal information for our legal, tax, audit,
						and accounting obligations, we will retain the necessary personal information
						for the period required by applicable law; and/or,
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 100px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Where necessary for our legitimate business interests, such as fraud prevention
						or maintaining the security of our users.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							7. Your rights
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						General Data
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Protection Regulations grant you certain rights (&#39; information rights&#39;)
						which provide you with:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 91px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						i.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Right of rectification or erasure
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						- if you feel that any data that we hold about you is inaccurate, you
						have the right to ask us to correct or rectify it. You also have a right
						to ask us to erase information about you where you can demonstrate that
						the data we hold is no longer needed by us if you withdraw the consent
						upon which our processing is based or if you feel that we are unlawfully
						processing your data. Your right of rectification and erasure extends to
						anyone to whom we have disclosed your personal information, and we will/shall
						take all reasonable steps to inform those with whom we have shared your
						data about your request for erasure. Note that we may have a legal obligation
						to retain some or even all personal information about you under relevant
						laws. We may also have the legal right to retain the information you have
						requested to be erased.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 91px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						ii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Right to restriction of processing
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						- you have a right to request that we refrain from processing your data
						where you contest its accuracy, or the processing is unlawful and you have
						opposed its erasure, or where we don&#39;t need to hold your data anymore
						but you need us to in order to establish, exercise or defend any legal
						claims, or we are in dispute about the legality of our processing your
						personal information.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 91px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Right to object
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						- you have a right to object to our processing of your personal information
						where the basis of the processing is our legitimate interests, including
						but not limited to direct marketing and profiling.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 91px;">
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						iv.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Right to withdraw consent
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						- you have the right to withdraw your consent for the processing of your
						personal information where the processing is based on consent. To withdraw
						consent, please specify what you wish to withdraw consent for, by emailing
						us
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(0, 0, 255)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 91px;">
					<span style="font-family: &#39;Times New Roman&#39;">
						v.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;">
							Right of complaint
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						- if you are unhappy with the way we have used or are handling your personal
						information you have the right to lodge a complaint with the supervisory
						authority for data protection issues. We would, however, appreciate the
						chance to address your concerns before you approach the Supervisory Authority.
						So, please contact us by email at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(0, 0, 255)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							8. Keeping your data safe
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						As a matter of policy, we are committed to protecting your data, and as
						such, UC reagent takes precautions to protect your information. We adopt commercially
						reasonable measures to secure Personal Information by using physical and
						electronic measures designed to ensure the integrity and security of the
						Personal Information we hold. When you submit sensitive information via
						the Website, your information is protected. Any payment transactions will
						be encrypted using SSL technology.
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						However, please note that no method of transmission over the internet
						or electronic storage method is 100% secure. Although we will do our best
						to protect the personal information we gather about you, the transmission
						of information via the internet is not completely secure.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							9. Additional privacy rights for California residents
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						If you are a resident of California, this section provides additional
						information about specific rights regarding your personal information.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Personal Information we collect
						</span>
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The following is a list of personal information that we collect or have
						collected from California residents over the past twelve months. We will
						update this disclosure from time to time as appropriate.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Unique identifiers such as your first name, last name, or similar identifier,
						address, or IP address;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Internet or other electronic network activity information, including content
						interaction information, such as content downloads, search history, transaction
						and interaction data on your use of our Service and from links in our emails
						sent to you;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						geolocation data, such as the location of your device or computer;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						inference data, such as information about your purchase preferences, feedback,
						and survey responses;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Other information that identifies or can be reasonably associated with
						you (e.g., the information you voluntarily provide as you use the UC reagent
						services, such as additional profile information or user-generated content).
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							How we collect personal information
						</span>
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We obtain the categories of personal information listed above from the
						following sources:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Directly from our website users when they provide the information to us.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Indirectly from you as you navigate through the website. Information collected
						automatically may include usage details, IP addresses, and information
						collected through cookies, web beacons, and other tracking technologies.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						From third-party service providers.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Categories of personal information disclosed for our business purpose
						</span>
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The personal information that we disclosed about consumers for a business
						purpose over the past (12) twelve months falls into the following categories
						as established by the California Consumer Privacy Act:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Identifiers such as your name, email address, billing address, or IP address;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Personal information, such as a credit card number, for example, if we
						use a third-party payment processor;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Your age range, gender, or other protected classifications, for example,
						if you choose to participate in a survey distributed by us or fill the
						User Content form;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Geolocation data from your IP address
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Access request rights
						</span>
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You have the right to request that we disclose certain information to
						you about our collection and use of your personal information over the
						past twelve (12) months. But only you, or someone legally authorized to
						act on your behalf, may make a verifiable consumer request related to your
						personal information. Agents must submit proof that the consumer has authorized
						them to act on their behalf. Making a verifiable consumer request does
						not require you to create an account with us. We will only use personal
						information provided in a verifiable consumer request to verify the requestor&#39;s
						identity or authority to make the request. If you wish to do any of these
						things, please contact us. Once we receive and verify your request, we
						will disclose it to you. You may make up to two (2) requests, no more than
						twice in a twelve-month period for information as to:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The categories of personal information we collected about you or shared
						with our service providers for business purposes.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The categories of sources for the personal information we collected about
						you.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Our business or commercial purpose for collecting that personal information.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 96px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The specific pieces of personal information we collected about you.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Right to deletion of personal information
						</span>
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Under the California Consumer Privacy Act, you have the right to request
						the deletion of your personal information. If you wish to do this, please
						contact us. Depending on your data choices and subject to applicable regulations,
						certain services may be limited or unavailable.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may, however, deny your deletion request if retaining the information
						is necessary for us or our service providers(s) to:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Complete the purpose for which we collected the personal information,
						provide a service that you requested, take actions reasonably anticipated
						within the context of our ongoing business relationship with you, or otherwise
						perform our contract with you.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Detect security incidents, protect against malicious, deceptive, fraudulent,
						or illegal activity, or prosecute those responsible for such activities.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Exercise free speech; ensure another consumer&#39;s right to exercise
						their free speech rights or exercise another right provided for by law.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Comply with the California Electronic Communications Privacy Act (Cal.
						Penal Code
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Times Roman">
							§
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						1546 et. seq. or other legal obligation.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin: 0 0 15px 88px;">
					<span style="font-family: &#39;Arial Unicode MS&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Arial Unicode MS">
							●
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Make other internal and lawful uses of that information that are compatible
						with the context in which you provided it.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							No discrimination
						</span>
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You have the right not to receive discriminatory treatment for the exercise
						of your rights under the CCPA, and we will not discriminate against any
						consumer for exercising their rights under the California Consumer Privacy
						Act.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							10. Children under the age of 13/Age restriction
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Our Website and services are not directed to, and we do not knowingly
						collect personally identifiable information from, children under the age
						of thirteen (13). As a parent or guardian, if it is determined that such
						information has been inadvertently collected about anyone under the age
						of thirteen (13), please email us at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(0, 0, 255)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						, and we shall immediately take the necessary steps to ensure that such
						information is deleted from our system&#39;s database.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							11. Unsubscribe or opt-out
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;">
							Marketing emails:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						If you have subscribed to our email and electronic newsletter communications,
						you will always have the opportunity to unsubscribe from future communications.
						You will also have the opportunity to &quot;opt-out&quot; of commercial
						email from the applicable Service by following the unsubscribe instructions
						provided in the email you receive or by contacting us directly. We will
						continue to adhere to this Policy with respect to any personal information
						previously collected.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;">
							Interest-based advertising:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We may also make use of the information we gather about you to provide
						you with advertisements and offers that are more relevant to your interest.
						These advertisements may be based on the information we collect through
						cookies and other tracking technologies we use on our Website, emails,
						and other third-party Websites you visit.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;">
							Do not track
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						: We respect your privacy choices. However, as there is no universally
						accepted industry standard for responding to &#39;Do Not Track&#39; signals,
						we do not currently modify our data collection and usage practices when
						we receive such signals from your browser.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							12. Links to other websites
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						UC reagent
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						does not claim nor accept responsibility for any privacy policies, practices
						and/or procedures of other third-party websites or resources. Therefore,
						we encourage all users and visitors to be aware when they leave our Website
						and to read the privacy statements of every Website that collects personally
						identifiable information. This Privacy Policy Agreement applies only and
						solely to the information collected on our Website.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							13. Acceptance of Terms
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						By using this Website, you accept the terms and conditions stipulated
						in the Privacy Policy Agreement. If you do not agree with our terms and
						conditions, you should refrain from further use of our website. In addition,
						your continued use of our website following the posting of any updates
						or changes to our Terms shall mean that you agree and accept such changes.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							14. How to contact us
						</span>
					</strong>
				</p>
				<p style="font-size: medium; text-indent: 0px; text-wrap: wrap; margin: 0px 0px 15px; ;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Feedback, comments, requests for technical support, and other communications
						relating to the website and the services should be directed to us at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(0, 0, 255)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						.
					</span>
				</p>
			</div>
			<!--协议内容-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//content_box
	.content_box{
		padding: 20px 16px;
	}
}
</style>